import React from 'react';

import { Typography, List, ListItem, ListItemIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  },
  listItem: {
    paddingBottom: 0
  }
}));

export default function ListFeatures () {
  const classes = useStyles();
  return (
    <List disablePadding className={classes.root}>
      <ListItem disableGutters className={classes.listItem}>
        <ListItemIcon>
          <Icon size='md' type='woorank-success' color='success' />
        </ListItemIcon>
        <Typography>
          <Translate content='free_trial_ended_list_item_1' />
        </Typography>
      </ListItem>
      <ListItem disableGutters className={classes.listItem}>
        <ListItemIcon>
          <Icon size='md' type='woorank-success' color='success' />
        </ListItemIcon>
        <Typography>
          <Translate content='free_trial_ended_list_item_2' />
        </Typography>
      </ListItem>
      <ListItem disableGutters className={classes.listItem}>
        <ListItemIcon>
          <Icon size='md' type='woorank-success' color='success' />
        </ListItemIcon>
        <Typography>
          <Translate content='free_trial_ended_list_item_3' />
        </Typography>
      </ListItem>
      <ListItem disableGutters className={classes.listItem}>
        <ListItemIcon>
          <Icon size='md' type='woorank-success' color='success' />
        </ListItemIcon>
        <Typography>
          <Translate content='free_trial_ended_list_item_4' />
        </Typography>
      </ListItem>
    </List>
  );
}
